/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyOverview = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        slug: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};